import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { findSelectOption } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import { centroid, normalizePoint } from 'features/Responder/features/Zones';
import { useZones } from 'features/Responder/features/Zones';
import React from 'react';
import { Form } from 'react-bootstrap';

export default function ZonePrefill({
  onChangeField = () => {},
  onShapeModeChange = () => {},
  disabled = false,
  selectedZoneId = '',
}) {
  let zonesWithMeta = [];
  try {
    const zonesCtx = useZones();
    zonesWithMeta = zonesCtx?.zonesWithMeta || [];
  } catch (err) {
    zonesWithMeta = [];
  }

  const zoneOptions = zonesWithMeta.map((z) => ({
    value: `${z.id}`,
    label: z.name || `Zone ${z.id}`,
  }));

  return (
    <>
      <div className="fw-semibold small text-uppercase text-theme-muted mb-2">
        Pre-fill from Zone
      </div>
      <Form.Group>
        <BaseSelect
          isSearchable
          classNames={{ control: () => 'responder-input' }}
          selectProps={{
            'aria-label': 'Pre-fill from Zone',
            options: zoneOptions,
            value: findSelectOption(zoneOptions, selectedZoneId ?? ''),
            placeholder: '-- Select zone --',
            isDisabled: disabled,
            onChange: (option) => {
              if (disabled) return;
              const val = option?.value ?? '';
              if (!val) return;
              const sel = zonesWithMeta.find((z) => `${z.id}` === `${val}`);
              if (!sel) return;
              const raw =
                sel.polygon ?? sel.geometry?.points ?? sel.geometry?.coord ?? sel._points ?? [];
              const points = Array.isArray(raw)
                ? raw.map((pt) => normalizePoint(pt)).filter(Boolean)
                : [];
              const newGeometry = {
                type: 'zone',
                points,
                coord: points,
                isZone: true,
                zoneId: sel.id,
              };
              onChangeField('geometry', newGeometry);
              onChangeField('zoneId', sel.id);

              const zoneLabel = sel.name || `Zone ${sel.id}`;
              if (zoneLabel) {
                onChangeField('label', zoneLabel);
                onChangeField('address', zoneLabel);
              }
              const boundsCenter =
                sel?.bounds &&
                Number.isFinite(sel.bounds.north) &&
                Number.isFinite(sel.bounds.south) &&
                Number.isFinite(sel.bounds.east) &&
                Number.isFinite(sel.bounds.west)
                  ? {
                      lat: (sel.bounds.north + sel.bounds.south) / 2,
                      lng: (sel.bounds.east + sel.bounds.west) / 2,
                    }
                  : null;
              const center = centroid(points) || boundsCenter || points[0] || null;
              if (center) {
                onChangeField('lat', center.lat);
                onChangeField('lng', center.lng);
              }
              onChangeField('placeId', '');
            },
          }}
        />
      </Form.Group>
    </>
  );
}
